import React, { useRef } from 'react';
import style from './SearchBar.scss';
import SearchIcon from 'wix-ui-icons-common/Search';
import XIcon from 'wix-ui-icons-common/X';

export const SearchBar = ({ searchTerm, setSearchTerm, onXButtonClick }) => {
  const inputRef = useRef<HTMLInputElement>();
  React.useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div className={style.searchBarWrapper}>
      <SearchIcon className={style.searchIcon} />
      <input
        autoComplete="off"
        data-hook="search-input"
        name="searchInput"
        ref={inputRef}
        onChange={({ target: { value } }) => setSearchTerm(value)}
        className={style.searchInput}
        value={searchTerm}
        type="text"
        placeholder="Search..."
      />
      {searchTerm && (
        <span
          data-hook="x-icon"
          className={style.xIconWrapper}
          onClick={onXIconClickHandler}
        >
          <XIcon className={style.xIcon} />
        </span>
      )}
    </div>
  );

  function onXIconClickHandler() {
    onXButtonClick();
    setSearchTerm('');
  }
};
